// placeholder for the index file, add the export statements here
import { CustomerPaymentsOnboardingDialog } from './main';

export default CustomerPaymentsOnboardingDialog;

export { default as PaymentLinkJournalDropdown } from './components/PaymentLinkJournalDropdown';
export { default as AwaitingPensoPay } from './components/steps/AwaitingPensoPay';
export { default as PaymentMethodBadge } from './components/PaymentMethodBadge';
export * as PaymentAndAccountingSettings from './components/steps/PaymentAndAccountingSettings';

// assets
export { default as mobilepay } from './assets/mobilepay-2x.png';
export { default as pensopayLogo } from './assets/pensopay-logo.png';
